export default __webpack_public_path__ + "static/media/foto8.196492c8.jpg";